jQuery( document ).ready( function($) {

	// slick sliders
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		dots: false,
		arrows: true,
		centerMode: true,
		centerPadding: '60px',
		appendDots: $( '.page-slider-nav' )
	});

	$( '.testimonial-slider' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true,
		dots: false,
		arrows: false,
	});

	// $( '.gallery-slider' ).slick({
	// 	speed: 1000,
	// 	autoplay: false,
	// 	autoplaySpeed: 2000,
	// 	fade: true,
	// 	arrows: true,
	// 	centerMode: true,
	// 	centerPadding: '60px',
	// });

	$( '.gallery-slider' ).slick({
		infinite: true,
		// slidesToShow: 1,
		// slidesToScroll: 1,
		arrows: true,
		centerMode: true,
		// centerPadding: '100px',
		variableWidth: true
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.navigation' ).toggleClass( 'slidein' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.page-overlay' ).toggleClass( 'show' );
	});

	// add arrow to dropdown menu items
	$( '.menu-item-has-children' ).prepend( '<span></span>' );

	// toggle the sub menu
	$( '.menu-item-has-children' ).on( 'click', 'span', function(e) {
		$( this ).closest( 'li' ).find( '.sub-menu' ).toggleClass( 'shown' );
	});

	// scroll top
	$( 'a[href="#top"]' ).click(function() {
		$( 'html, body' ).animate({ scrollTop: 0 }, 'slow' );
		return false;
	});

	// animate scroll
	(function($) {

		/**
		* Copyright 2012, Digital Fusion
		* Licensed under the MIT license.
		* http://teamdf.com/jquery-plugins/license/
		*
		* @author Sam Sehnert
		* @desc A small plugin that checks whether elements are within
		*     the user visible viewport of a web browser.
		*     only accounts for vertical position, not horizontal.
		*/

		$.fn.visible = function(partial) {

		  var $t            = $(this),
			  $w            = $(window),
			  viewTop       = $w.scrollTop(),
			  viewBottom    = viewTop + $w.height(),
			  _top          = $t.offset().top +50,
			  _bottom       = _top + $t.height(),
			  compareTop    = partial === true ? _bottom : _top,
			  compareBottom = partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

		};
		
	})(jQuery);

	var win = $(window);

	var allMods = $( '.animate-in' );

	allMods.each(function(i, el) {
	  var el = $(el);
	  if (el.visible(true)) {
		el.addClass( 'fully-visible' ); 
	  } 
	});

	win.scroll(function(event) {
	  
	  allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
		  el.addClass( 'visible' ); 
		} 
	  });
	  
	});

});